<template>
  <div class="app-container">
    <!-- 数据统计卡片 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="4" v-for="item in statCards" :key="item.key">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value">{{ item.value }}</div>
          <div class="stat-label">{{ item.label }}</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- CK 数据统计卡片 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="4" v-for="item in ckStatCards" :key="item.key">
        <el-card shadow="hover" class="stat-card ck-stat">
          <div class="stat-value ck">{{ item.value }}</div>
          <div class="stat-label">{{ item.label }}</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 广告结构管理 + 消耗数据管理 -->
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12" v-if="isDev">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span><i class="el-icon-office-building"></i> 广告结构管理</span>
            <el-tag size="mini" type="warning">PG维表 + 素材映射</el-tag>
          </div>

          <!-- 共用参数 -->
          <el-form :inline="true" size="small" label-width="110px">
            <el-form-item label="每账户系列数">
              <el-input-number v-model="structureParams.campaignsMin" :min="1" controls-position="right" style="width: 80px" /> ~
              <el-input-number v-model="structureParams.campaignsMax" :min="1" controls-position="right" style="width: 80px" />
            </el-form-item>
          </el-form>
          <el-form :inline="true" size="small" label-width="110px">
            <el-form-item label="每系列广告组">
              <el-input-number v-model="structureParams.adsetsMin" :min="1" controls-position="right" style="width: 80px" /> ~
              <el-input-number v-model="structureParams.adsetsMax" :min="1" controls-position="right" style="width: 80px" />
            </el-form-item>
          </el-form>
          <el-form :inline="true" size="small" label-width="110px">
            <el-form-item label="每组广告数">
              <el-input-number v-model="structureParams.adsMin" :min="1" controls-position="right" style="width: 80px" /> ~
              <el-input-number v-model="structureParams.adsMax" :min="1" controls-position="right" style="width: 80px" />
            </el-form-item>
          </el-form>

          <!-- 生成广告结构：新建账户，不建映射 -->
          <div class="section-label" style="margin-top: 14px;"><i class="el-icon-magic-stick"></i> 生成广告结构</div>
          <el-form :inline="true" size="small" label-width="110px">
            <el-form-item label="账户数">
              <el-input-number v-model="structureParams.accounts" :min="1" controls-position="right" style="width: 100px" />
            </el-form-item>
          </el-form>
          <div style="margin-top: 6px;">
            <el-button type="primary" size="small" icon="el-icon-magic-stick" :loading="generating.structure" @click="handleGenerateStructure">生成广告结构</el-button>
          </div>

          <!-- 基于当前账户扩展：不建映射 -->
          <div class="section-label" style="margin-top: 16px;"><i class="el-icon-plus"></i> 基于当前账户扩展</div>
          <el-form :inline="true" size="small" label-width="110px">
            <el-form-item label="扩展参与账户">
              <el-input-number v-model="structureParams.accountLimit" :min="0" controls-position="right" style="width: 90px" />
              <el-tooltip placement="top" :content="'0=使用全部现有账户（当前共 ' + (stats.accountCount || 0) + ' 个）；>0=只用前N个'">
                <i class="el-icon-question" style="margin-left: 6px; color: #909399; cursor: help"></i>
              </el-tooltip>
            </el-form-item>
          </el-form>
          <el-form :inline="true" size="small" label-width="110px">
            <el-form-item label="创建时间区间">
              <el-date-picker
                v-model="structureParams.expandCreatedTimeRange"
                type="daterange"
                size="small"
                style="width: 240px"
                range-separator="至"
                start-placeholder="开始"
                end-placeholder="结束"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
              />
              <span style="margin-left: 4px; color: #909399; font-size: 12px">可选</span>
            </el-form-item>
          </el-form>
          <div style="margin-top: 6px;">
            <div class="estimate-line" v-if="expandEstimate" style="margin-bottom: 4px;"><i class="el-icon-data-analysis"></i> {{ expandEstimate }}</div>
            <el-button type="success" size="small" icon="el-icon-plus" :loading="generating.expandStruct" @click="handleExpandStructure">基于当前账户扩展</el-button>
          </div>
          <div class="info-text" style="margin-top: 12px; font-size: 12px;">
            生成、扩展均不建映射。需映射请执行分步操作→步骤1。
          </div>

          <el-divider></el-divider>
          <el-button type="danger" plain icon="el-icon-delete" size="small" :loading="clearing.ckAll" @click="handleClearCkAll">全量清除维表+映射+消耗</el-button>
        </el-card>
      </el-col>

      <!-- 消耗数据管理 -->
      <el-col :span="isDev ? 12 : 24">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span><i class="el-icon-coin"></i> 消耗数据管理</span>
            <el-tag size="mini" type="warning">CK fact_insights + PG消耗</el-tag>
          </div>

          <el-form :inline="true" size="small" label-width="110px">
            <el-form-item label="日期区间">
              <el-date-picker
                v-model="insightsDateRange"
                type="daterange"
                size="small"
                style="width: 280px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
                @change="handleInsightsDateChange"
              />
            </el-form-item>
          </el-form>

          <div style="margin-bottom: 12px;">
            <el-button type="primary" icon="el-icon-download" size="small" :loading="generating.syncAdsBackend" @click="handleSyncFromAdsBackend">AdsBackend 数据同步</el-button>
            <span class="hint-text">从司海自动投放平台拉取账户/系列/广告组/广告及消耗，写入本地 PG fact_insights_daily。可选日期区间，不选则近7天</span>
          </div>

          <div v-if="isDev">
            <div v-show="showInsightsAdvanced" style="margin-top: 10px;">
            <el-form :inline="true" size="small" label-width="120px">
              <el-form-item label="每日消耗($)">
                <el-input-number v-model="insightsParams.spendMin" :min="0" :precision="2" controls-position="right" style="width: 100px" /> ~
                <el-input-number v-model="insightsParams.spendMax" :min="0.01" :precision="2" controls-position="right" style="width: 100px" />
              </el-form-item>
            </el-form>
            <el-form :inline="true" size="small" label-width="120px">
              <el-form-item label="展示量">
                <el-input-number v-model="insightsParams.impressionsMin" :min="1" controls-position="right" style="width: 110px" /> ~
                <el-input-number v-model="insightsParams.impressionsMax" :min="1" controls-position="right" style="width: 110px" />
              </el-form-item>
            </el-form>
            <el-form :inline="true" size="small" label-width="120px">
              <el-form-item label="点击率上限">
                <el-input-number v-model="insightsParams.ctrMax" :min="0.001" :step="0.01" :precision="3" controls-position="right" style="width: 100px" />
              </el-form-item>
              <el-form-item label="转化率上限">
                <el-input-number v-model="insightsParams.convRateMax" :min="0" :step="0.01" :precision="3" controls-position="right" style="width: 100px" />
              </el-form-item>
            </el-form>
            <el-form :inline="true" size="small" label-width="120px">
              <el-form-item label="单次购物价值($)">
                <el-input-number v-model="insightsParams.purchaseValueMin" :min="0" :precision="2" controls-position="right" style="width: 100px" /> ~
                <el-input-number v-model="insightsParams.purchaseValueMax" :min="0.01" :precision="2" controls-position="right" style="width: 100px" />
              </el-form-item>
            </el-form>
          </div>

          <el-button type="text" size="mini" @click="showInsightsAdvanced = !showInsightsAdvanced" style="margin-top: 4px;">
            {{ showInsightsAdvanced ? '收起高级参数 ▲' : '展开高级参数 ▼' }}
          </el-button>

          <div style="margin-top: 12px;">
            <el-button type="primary" icon="el-icon-magic-stick" :loading="generating.insights" @click="handleGenerateInsights">生成消耗数据</el-button>
            <el-button type="warning" plain icon="el-icon-delete" size="small" :loading="clearing.ck" @click="handleClearCkRange">清除当前区间</el-button>
          </div>

          <div class="info-text" style="margin-top: 8px;">
            读取系统中已有广告，按日期区间生成随机消耗。写入 CK（ad/adset/campaign 三层）+ PG fact_insights_daily + PG 素材消耗汇总。
            需先运行「生成广告结构」。
          </div>
          </div>

          <el-divider v-if="isDev"></el-divider>
          <div style="margin-bottom: 8px;">
            <span class="hint-text" style="margin-right: 8px;">素材消耗聚合日期（可选，不填则自动全量/90天）：</span>
            <el-date-picker
              v-model="aggregateDateRange"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 260px; margin-right: 8px"
              :picker-options="datePickerOptions"
            />
            <el-button type="primary" plain icon="el-icon-data-analysis" size="small" :loading="generating.aggregateMat" @click="handleAggregateMaterialConsumption">素材消耗聚合</el-button>
          </div>
          <div class="info-text" style="margin-top: -4px; margin-bottom: 8px;">
            从 CK ad 层 + 映射聚合，写入 PG 和 CK material_consumption_daily。指定日期可覆盖 90 天限制（如 2025-08-31 ~ 2026-02-07）
          </div>
          <div style="margin-bottom: 4px; display: flex; align-items: center; flex-wrap: wrap; gap: 8px;">
            <span style="font-size: 12px; color: #606266; white-space: nowrap;">PG→CK 日期（可选，不填则全量）：</span>
            <el-date-picker
              v-model="rebuildCkDateRange"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 260px;"
              :picker-options="datePickerOptions"
            />
          </div>
          <div style="margin-bottom: 8px; display: flex; align-items: center; flex-wrap: wrap; gap: 8px;">
            <el-button type="success" plain icon="el-icon-upload2" size="small" :loading="generating.rebuildCk" @click="handleRebuildCkFromPg">PG→CK 重建</el-button>
            <el-select v-model="rebuildCkLevel" size="small" style="width: 110px;" placeholder="全部维度" clearable>
              <el-option label="全部维度" value="" />
              <el-option label="仅 Campaign" value="campaign" />
              <el-option label="仅 Adset" value="adset" />
              <el-option label="仅 Ad" value="ad" />
            </el-select>
            <el-tag v-if="rebuildCkDateRange && rebuildCkDateRange.length === 2" type="info" size="small" style="font-family: monospace;">
              {{ rebuildCkDateRange[0] }} ~ {{ rebuildCkDateRange[1] }}
            </el-tag>
            <el-tag v-else type="warning" size="small">全量（PG 所有数据）</el-tag>
            <span class="hint-text">从 PG fact_insights_daily 同步到 CK，CK 清空/损坏后可恢复；指定维度时只覆盖该层，其他层不受影响</span>
          </div>
          <div style="margin-bottom: 8px;">
            <el-button type="info" plain icon="el-icon-download" size="small" :loading="generating.initPg" @click="handleInitPgFromCk">CK→PG 初始化</el-button>
            <span class="hint-text">将 CK 数据迁移到 PG，首次部署或回填主存储</span>
          </div>
          <el-divider></el-divider>
          <el-button type="danger" plain icon="el-icon-delete" size="small" :loading="clearing.ckTruncate" @click="handleTruncateCk">清空 CK 表 (TRUNCATE)</el-button>
          <span class="hint-text">清空 CK 两张表（fact_insights_daily + material_consumption_daily），不影响 PG 数据</span>
        </el-card>
      </el-col>
    </el-row>

    <!-- 分步操作（映射 → PG消耗 → CK+统计） -->
    <el-row :gutter="20" style="margin-top: 20px;" v-if="isDev">
      <el-col :span="24">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span><i class="el-icon-s-operation"></i> 分步操作</span>
            <el-tag size="mini" type="primary">映射 → PG → CK+统计</el-tag>
          </div>
          <div class="info-text" style="margin-bottom: 16px;">
            基于现有 fb_ad，先建映射 → 再生成 PG fact_insights_daily → 最后同步到 CK 并聚合素材消耗
          </div>
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="step-box">
                <div class="step-title">步骤1：生成映射</div>
                <div class="step-desc">为 AD 随机分配素材，建立 material_ad_mapping</div>
                <el-form size="small" label-width="120px" class="step-form">
                  <el-form-item label="AD 覆盖率(%)">
                    <el-input-number v-model="step1Params.mappingCoveragePercent" :min="1" :max="100" controls-position="right" style="width: 100%" />
                    <span class="param-hint">参与映射的 AD 比例，如 60% 表示 60% 的 AD 会有映射</span>
                  </el-form-item>
                  <el-form-item label="素材覆盖率(%)">
                    <el-input-number v-model="step1Params.materialCoveragePercent" :min="0" :max="100" controls-position="right" style="width: 100%" />
                    <span class="param-hint">0=用全部素材；>0=只用该比例素材，使一素材多 AD</span>
                  </el-form-item>
                  <el-form-item label="参与素材数">
                    <el-input-number v-model="step1Params.materialLimit" :min="0" controls-position="right" style="width: 100%" />
                    <span class="param-hint">0=按覆盖率；>0=强制只用 N 个素材（覆盖覆盖率）</span>
                  </el-form-item>
                  <el-form-item label="目标映射条数">
                    <el-input-number v-model="step1Params.targetMappingCount" :min="0" controls-position="right" style="width: 100%" />
                    <span class="param-hint">0=按覆盖率算；>0=强制生成 N 条（覆盖覆盖率设定）</span>
                  </el-form-item>
                  <el-form-item label="清空旧映射">
                    <el-switch v-model="step1Params.clearExisting" />
                  </el-form-item>
                </el-form>
                <div class="estimate-line"><i class="el-icon-data-analysis"></i> {{ step1Estimate }}</div>
                <div class="formula-hint">X% AD 映射到 Y% 素材，一素材多 AD。映射数 ≈ AD数×AD覆盖率</div>
                <el-button type="primary" size="small" :loading="generating.step1" @click="handleStep1" class="step-btn">执行步骤1</el-button>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="step-box">
                <div class="step-title">步骤2：生成 PG 消耗</div>
                <div class="step-desc">为每个 AD 按日期生成随机 spend/impressions 等</div>
                <el-form size="small" label-width="100px" class="step-form">
                  <el-form-item label="日期区间">
                    <el-date-picker v-model="step2DateRange" type="daterange" range-separator="至" start-placeholder="开始" end-placeholder="结束" value-format="yyyy-MM-dd" style="width: 100%" :picker-options="datePickerOptions" />
                  </el-form-item>
                  <el-form-item label="每日消耗($)">
                    <el-input-number v-model="insightsParams.spendMin" :min="0" :precision="2" size="small" style="width: 90px" /> ~
                    <el-input-number v-model="insightsParams.spendMax" :min="0.01" :precision="2" size="small" style="width: 90px" />
                    <span class="param-hint">每条记录的 spend 随机范围</span>
                  </el-form-item>
                  <el-form-item label="展示量">
                    <el-input-number v-model="insightsParams.impressionsMin" :min="1" size="small" style="width: 90px" /> ~
                    <el-input-number v-model="insightsParams.impressionsMax" :min="1" size="small" style="width: 90px" />
                    <span class="param-hint">每条记录的 impressions 随机范围</span>
                  </el-form-item>
                  <div v-show="showStep2Advanced">
                    <el-form-item label="点击率上限">
                      <el-input-number v-model="insightsParams.ctrMax" :min="0.001" :step="0.01" :precision="3" size="small" style="width: 90px" />
                    </el-form-item>
                    <el-form-item label="转化率上限">
                      <el-input-number v-model="insightsParams.convRateMax" :min="0" :step="0.01" :precision="3" size="small" style="width: 90px" />
                    </el-form-item>
                    <el-form-item label="购物价值($)">
                      <el-input-number v-model="insightsParams.purchaseValueMin" :min="0" :precision="2" size="small" style="width: 80px" /> ~
                      <el-input-number v-model="insightsParams.purchaseValueMax" :min="0.01" :precision="2" size="small" style="width: 80px" />
                    </el-form-item>
                  </div>
                  <el-button type="text" size="mini" @click="showStep2Advanced = !showStep2Advanced">{{ showStep2Advanced ? '收起 ▲' : '更多指标 ▼' }}</el-button>
                </el-form>
                <div class="estimate-line"><i class="el-icon-data-analysis"></i> {{ step2Estimate }}</div>
                <div class="formula-hint">公式：行数 = 天数 × (AD数+广告组数+系列数)，ad/adset/campaign 三层各每天一行</div>
                <el-button type="primary" size="small" :loading="generating.step2" @click="handleStep2" class="step-btn">执行步骤2</el-button>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="step-box">
                <div class="step-title">步骤3：CK 同步 + 聚合</div>
                <div class="step-desc">PG fact_insights → CK，再按映射聚合素材消耗</div>
                <el-form size="small" label-width="100px" class="step-form">
                  <el-form-item label="日期区间">
                    <el-date-picker v-model="step3DateRange" type="daterange" range-separator="至" start-placeholder="可选" end-placeholder="可选" value-format="yyyy-MM-dd" style="width: 100%" :picker-options="datePickerOptions" />
                    <el-button type="text" size="mini" @click="step3DateRange = step2DateRange && step2DateRange.length === 2 ? [...step2DateRange] : null">与步骤2同步</el-button>
                  </el-form-item>
                  <span class="param-hint">不填则用 PG 最小~最大日期，建议与步骤2一致</span>
                </el-form>
                <div class="estimate-line"><i class="el-icon-data-analysis"></i> {{ step3Estimate }}</div>
                <el-button type="primary" size="small" :loading="generating.step3" @click="handleStep3" class="step-btn">执行步骤3</el-button>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <!-- 测试素材生成 -->
    <el-row :gutter="20" style="margin-top: 20px;" v-if="isDev">
      <el-col :span="24">
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span><i class="el-icon-picture-outline"></i> 测试素材生成</span>
            <el-tag size="mini" type="success">material</el-tag>
          </div>

          <el-form :inline="true" size="small" label-width="100px">
            <el-form-item label="生成数量">
              <el-input-number
                v-model="materialParams.count"
                :min="1"
                :max="100000"
                :step="100"
                controls-position="right"
                style="width: 150px"
              />
            </el-form-item>
            <el-form-item label="素材类型">
              <el-select v-model="materialParams.type" style="width: 110px">
                <el-option label="图片" value="image" />
                <el-option label="视频" value="video" />
              </el-select>
            </el-form-item>
            <el-form-item label="文件大小(KB)">
              <el-input-number
                v-model="materialParams.fileSizeKb"
                :min="1"
                :max="50"
                controls-position="right"
                style="width: 100px"
              />
            </el-form-item>
            <el-form-item label="名称前缀">
              <el-input
                v-model="materialParams.namePrefix"
                placeholder="测试素材"
                style="width: 150px"
              />
            </el-form-item>
          </el-form>

          <el-form :inline="true" size="small" label-width="100px" v-show="showMaterialAdvanced">
            <el-form-item label="宽度(px)">
              <el-input-number
                v-model="materialParams.width"
                :min="1"
                :max="2000"
                controls-position="right"
                style="width: 120px"
              />
            </el-form-item>
            <el-form-item label="高度(px)">
              <el-input-number
                v-model="materialParams.height"
                :min="1"
                :max="2000"
                controls-position="right"
                style="width: 120px"
              />
            </el-form-item>
          </el-form>

          <div style="margin-top: 8px;">
            <el-button type="text" size="mini" @click="showMaterialAdvanced = !showMaterialAdvanced">
              {{ showMaterialAdvanced ? '收起高级参数 ▲' : '展开高级参数 ▼' }}
            </el-button>
          </div>

          <!-- 操作按钮 -->
          <div style="margin-top: 12px;">
            <el-button
              type="primary"
              icon="el-icon-magic-stick"
              :loading="generating.materials"
              @click="handleGenerateMaterials"
            >生成测试素材</el-button>
            <el-button
              type="danger"
              plain
              icon="el-icon-delete"
              :loading="clearing.materials"
              @click="handleClearMaterials"
            >清除测试素材</el-button>
          </div>

          <div class="info-text" style="margin-top: 8px;">
            批量生成 <b>{{ materialParams.count }}</b> 个测试{{ materialParams.type === 'image' ? '图片' : '视频' }}素材（每个约 <b>{{ materialParams.fileSizeKb }}KB</b>，
            共约 <b>{{ (materialParams.count * materialParams.fileSizeKb / 1024).toFixed(1) }}MB</b>），
            分散到 <b>{{ Math.ceil(materialParams.count / 500) }}</b> 个子目录（每目录最多500个文件）。
            8线程并行写文件 + JDBC批量插入。
            <span v-if="materialParams.count >= 10000" style="color: #E6A23C;">
              预估耗时约 <b>{{ Math.ceil(materialParams.count / 1500) }}~{{ Math.ceil(materialParams.count / 800) }}</b> 秒，请耐心等待。
            </span>
            清除操作仅删除名称前缀匹配的测试素材（含物理文件和空目录）。
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 快捷操作 -->
    <el-card shadow="never" style="margin-top: 20px;">
      <div slot="header" class="card-header">
        <span><i class="el-icon-set-up"></i> 快捷操作</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="8" v-if="isDev">
          <el-button
            type="success"
            icon="el-icon-s-promotion"
            style="width: 100%"
            :loading="generating.rebuild"
            @click="handleRebuildMaterialConsumption"
          >一键重建素材消耗</el-button>
          <div class="info-text" style="margin-top: 8px; text-align: center;">
            清除→广告结构→消耗→聚合（按正确顺序，object_id 与 fb_ad_id 一致）
          </div>
        </el-col>
        <el-col :span="4">
          <el-button
            type="warning"
            icon="el-icon-refresh-left"
            style="width: 100%"
            @click="handleRefreshStats"
          >刷新统计</el-button>
          <div class="info-text" style="margin-top: 8px; text-align: center;">
            重新查询各表数据量
          </div>
        </el-col>
        <el-col :span="12" v-if="isDev">
          <el-button
            type="danger"
            icon="el-icon-delete-solid"
            style="width: 100%"
            :loading="clearing.ckAll"
            @click="handleClearCkAll"
          >全量清除所有测试数据</el-button>
          <div class="info-text" style="margin-top: 8px; text-align: center;">
            CK + PG维表 + 映射 + 消耗 全部删除
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 操作日志 -->
    <el-card shadow="never" style="margin-top: 20px;" v-if="logs.length > 0">
      <div slot="header" class="card-header">
        <span><i class="el-icon-document"></i> 操作日志</span>
        <el-button type="text" size="mini" @click="logs = []">清空</el-button>
      </div>
      <div class="log-container">
        <div v-for="(logItem, idx) in logs" :key="idx" class="log-item" :class="logItem.type">
          <span class="log-time">{{ logItem.time }}</span>
          <el-tag :type="logItem.type === 'success' ? 'success' : logItem.type === 'error' ? 'danger' : 'info'" size="mini">
            {{ logItem.type === 'success' ? '成功' : logItem.type === 'error' ? '失败' : '信息' }}
          </el-tag>
          <span class="log-msg">{{ logItem.message }}</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStats, generateStructure, generateInsights, expandStructureFromAccounts, clearCk, rebuildCkFromPg, initPgFromCk, aggregateMaterialConsumption, rebuildMaterialConsumption, generateMaterials, clearMaterials, step1CreateMapping, step2GeneratePgInsights, step3SyncCkAndAggregate, syncFromAdsBackend } from '@/api/dev/devTools';
import { withLocalDevLongRangeDateShortcuts } from '@/utils/dateRangePickerOptions';

export default {
  name: 'DevTools',
  data() {
    return {
      /** 统计数据 */
      stats: {},
      /** 广告结构参数 */
      structureParams: {
        accounts: 3,
        accountLimit: 0,
        expandCreatedTimeRange: null,
        campaignsMin: 2,
        campaignsMax: 5,
        adsetsMin: 1,
        adsetsMax: 4,
        adsMin: 1,
        adsMax: 4
      },
      /** 消耗数据日期区间 */
      insightsDateRange: [],
      /** 素材消耗聚合日期区间（可选，不填则自动） */
      aggregateDateRange: null,
      /** 消耗数据参数 */
      insightsParams: {
        startDate: undefined,
        endDate: undefined,
        spendMin: 5,
        spendMax: 300,
        impressionsMin: 500,
        impressionsMax: 30000,
        ctrMax: 0.06,
        convRateMax: 0.12,
        purchaseValueMin: 15,
        purchaseValueMax: 90
      },
      showInsightsAdvanced: false,
      /** 日期快捷选项 */
      datePickerOptions: withLocalDevLongRangeDateShortcuts([
        { text: '近7天', onClick(picker) { const e = new Date(); e.setDate(e.getDate() - 1); const s = new Date(); s.setDate(s.getDate() - 7); picker.$emit('pick', [s, e]); } },
        { text: '近30天', onClick(picker) { const e = new Date(); e.setDate(e.getDate() - 1); const s = new Date(); s.setDate(s.getDate() - 30); picker.$emit('pick', [s, e]); } },
        { text: '近90天', onClick(picker) { const e = new Date(); e.setDate(e.getDate() - 1); const s = new Date(); s.setDate(s.getDate() - 90); picker.$emit('pick', [s, e]); } },
        { text: '近180天', onClick(picker) { const e = new Date(); e.setDate(e.getDate() - 1); const s = new Date(); s.setDate(s.getDate() - 180); picker.$emit('pick', [s, e]); } },
        { text: '近365天', onClick(picker) { const e = new Date(); e.setDate(e.getDate() - 1); const s = new Date(); s.setDate(s.getDate() - 365); picker.$emit('pick', [s, e]); } }
      ]),
      /** 素材生成参数 */
      materialParams: {
        count: 10,
        type: 'image',
        namePrefix: '测试素材',
        fileSizeKb: 3,
        width: 200,
        height: 200
      },
      showMaterialAdvanced: false,
      /** 分步操作参数 */
      step1Params: {
        mappingCoveragePercent: 60,
        materialCoveragePercent: 60,
        materialLimit: 0,
        targetMappingCount: 0,
        clearExisting: true
      },
      step2DateRange: null,
      step3DateRange: null,
      showStep2Advanced: false,
      /** PG→CK 重建日期区间（null=全量） */
      rebuildCkDateRange: null,
      /** PG→CK 重建维度筛选（空字符串=全部维度） */
      rebuildCkLevel: '',
      /** 生成中状态 */
      generating: {
        structure: false,
        expandStruct: false,
        insights: false,
        materials: false,
        rebuildCk: false,
        initPg: false,
        aggregateMat: false,
        syncAdsBackend: false,
        rebuild: false,
        step1: false,
        step2: false,
        step3: false
      },
      /** 清除中状态 */
      clearing: {
        ck: false,
        ckAll: false,
        ckTruncate: false,
        materials: false
      },
      /** 操作日志 */
      logs: []
    };
  },
  computed: {
    isDev() {
      return true; // 生产环境也强制放开展示
    },
    /** PG 统计卡片配置 */
    statCards() {
      return [
        { key: 'accountCount', label: '账户数', value: this.stats.accountCount || 0 },
        { key: 'campaignCount', label: '系列数', value: this.stats.campaignCount || 0 },
        { key: 'adsetCount', label: '广告组数', value: this.stats.adsetCount || 0 },
        { key: 'adCount', label: 'AD数', value: this.stats.adCount || 0 },
        { key: 'materialCount', label: '素材数', value: this.stats.materialCount || 0 },
        { key: 'pgFactInsightsCount', label: 'PG fact_insights', value: this.stats.pgFactInsightsCount || 0 },
        { key: 'consumptionDailyCount', label: 'PG消耗明细数', value: this.stats.consumptionDailyCount || 0 },
        { key: 'consumptionMaterialCount', label: '有消耗的素材', value: this.stats.consumptionMaterialCount || 0 },
        { key: 'mappingCount', label: '映射关系数', value: this.stats.mappingCount || 0 },
        { key: 'mappingMaterialCount', label: '有映射的素材', value: this.stats.mappingMaterialCount || 0 },
        { key: 'dateRange', label: 'PG消耗日期范围', value: this.dateRangeText }
      ];
    },
    /** CK 统计卡片配置 */
    ckStatCards() {
      return [
        { key: 'ckTotalRows', label: 'CK总行数', value: this.stats.ckTotalRows || 0 },
        { key: 'ckAccountCount', label: 'CK账户数', value: this.stats.ckAccountCount || 0 },
        { key: 'ck_campaign', label: 'campaign层', value: this.stats.ck_campaign || 0 },
        { key: 'ck_adset', label: 'adset层', value: this.stats.ck_adset || 0 },
        { key: 'ck_ad', label: 'ad层', value: this.stats.ck_ad || 0 },
        { key: 'ckDateRange', label: 'CK日期范围', value: this.ckDateRangeText }
      ];
    },
    /** PG日期范围文本 */
    dateRangeText() {
      const min = this.stats.consumptionMinDate;
      const max = this.stats.consumptionMaxDate;
      if (!min || !max) return '无';
      return min + ' ~ ' + max;
    },
    /** CK日期范围文本 */
    ckDateRangeText() {
      const min = this.stats.ckMinDate;
      const max = this.stats.ckMaxDate;
      if (!min || !max) return '无';
      return min + ' ~ ' + max;
    },
    /** 步骤1预估：映射条数、素材池、一素材约X AD */
    step1Estimate() {
      const adCount = this.stats.adCount || 0;
      const materialCount = this.stats.materialCount || 0;
      const target = this.step1Params.targetMappingCount;
      const adCov = (this.step1Params.mappingCoveragePercent || 60) / 100;
      const matCov = this.step1Params.materialLimit > 0
        ? this.step1Params.materialLimit / materialCount
        : (this.step1Params.materialCoveragePercent || 0) / 100;
      if (adCount === 0 || materialCount === 0) return '需先有 AD 和素材，请刷新统计';
      const estMap = target > 0 ? Math.min(target, adCount) : Math.floor(adCount * adCov);
      const poolSize = this.step1Params.materialLimit > 0
        ? Math.min(this.step1Params.materialLimit, materialCount)
        : matCov > 0 ? Math.max(1, Math.round(materialCount * matCov)) : materialCount;
      const perMat = poolSize > 0 ? (estMap / poolSize).toFixed(1) : '0';
      return `约 ${estMap.toLocaleString()} 条，素材池 ${poolSize.toLocaleString()} 个，一素材约 ${perMat} 个 AD`;
    },
    /** 步骤2预估：PG 行数、天数 */
    step2Estimate() {
      const adCount = this.stats.adCount || 0;
      const adsetCount = this.stats.adsetCount || 0;
      const campaignCount = this.stats.campaignCount || 0;
      const range = this.step2DateRange;
      if (!range || range.length !== 2 || adCount === 0) return '需选择日期区间';
      const start = new Date(range[0]);
      const end = new Date(range[1]);
      const days = Math.max(1, Math.ceil((end - start) / 86400000) + 1);
      const rows = days * (adCount + adsetCount + campaignCount);
      return `约 ${rows.toLocaleString()} 行（${days}天 × ad+adset+campaign）`;
    },
    /** 步骤3说明 */
    step3Estimate() {
      const pgCount = this.stats.pgFactInsightsCount || 0;
      const mapCount = this.stats.mappingCount || 0;
      if (pgCount === 0) return '需先执行步骤2';
      return `同步 ${pgCount.toLocaleString()} 行到 CK，聚合约 ${mapCount.toLocaleString()} 个 AD 的素材消耗`;
    },
    /** 扩展结构预估：参与账户、系列、组、广告（不建映射） */
    expandEstimate() {
      const total = this.stats.accountCount || 0;
      const limit = this.structureParams.accountLimit || 0;
      const n = limit === 0 ? total : Math.min(limit, total);
      if (n === 0) return '当前无账户，请先同步 Facebook 账户';
      const cm = (this.structureParams.campaignsMin || 2) + (this.structureParams.campaignsMax || 5);
      const am = (this.structureParams.adsetsMin || 1) + (this.structureParams.adsetsMax || 4);
      const dm = (this.structureParams.adsMin || 1) + (this.structureParams.adsMax || 4);
      const estC = Math.round(n * cm / 2);
      const estA = Math.round(estC * am / 2);
      const estD = Math.round(estA * dm / 2);
      return `参与 ${n} 个账户，预估 系列 ${estC.toLocaleString()}、组 ${estA.toLocaleString()}、广告 ${estD.toLocaleString()}（不建映射）`;
    }
  },
  created() {
    // 设置默认日期区间：近7天（昨天往前推7天）
    const end = new Date();
    end.setDate(end.getDate() - 1);
    const start = new Date();
    start.setDate(start.getDate() - 7);
    const fmt = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    this.insightsDateRange = [fmt(start), fmt(end)];
    this.insightsParams.startDate = fmt(start);
    this.insightsParams.endDate = fmt(end);
    this.step2DateRange = [fmt(start), fmt(end)];
    this.handleRefreshStats();
  },
  methods: {
    /** 消耗数据日期区间变更 */
    handleInsightsDateChange(val) {
      if (val && val.length === 2) {
        this.insightsParams.startDate = val[0];
        this.insightsParams.endDate = val[1];
      } else {
        this.insightsParams.startDate = undefined;
        this.insightsParams.endDate = undefined;
      }
    },
    /** 刷新统计 */
    async handleRefreshStats() {
      try {
        const res = await getStats();
        this.stats = res.data || {};
        const pgMs = this.stats._pgTotalMs;
        const ckMs = this.stats._ckTotalMs;
        const timing = (pgMs != null || ckMs != null)
          ? ' (PG: ' + (pgMs || 0) + 'ms, CK: ' + (ckMs || 0) + 'ms)'
          : '';
        this.addLog('info', '统计数据已刷新' + timing);
      } catch (e) {
        this.addLog('error', '获取统计数据失败: ' + (e.message || e));
      }
    },

    /** 生成广告结构 */
    async handleGenerateStructure() {
      this.generating.structure = true;
      try {
        const params = {
          accounts: this.structureParams.accounts,
          campaignsMin: this.structureParams.campaignsMin,
          campaignsMax: this.structureParams.campaignsMax,
          adsetsMin: this.structureParams.adsetsMin,
          adsetsMax: this.structureParams.adsetsMax,
          adsMin: this.structureParams.adsMin,
          adsMax: this.structureParams.adsMax
        };
        const res = await generateStructure(params);
        const d = res.data || {};
        const msg = '账户: ' + (d.accounts || 0) + ', 系列: ' + (d.campaigns || 0) + ', 组: ' + (d.adsets || 0) + ', 广告: ' + (d.ads || 0);
        this.$message.success('广告结构生成成功! ' + msg);
        this.addLog('success', '生成广告结构: ' + msg);
        await this.handleRefreshStats();
      } catch (e) {
        this.$message.error('生成失败: ' + (e.message || e));
        this.addLog('error', '生成广告结构失败: ' + (e.message || e));
      } finally {
        this.generating.structure = false;
      }
    },

    /** 基于当前账户扩展结构（系列/广告组/AD） */
    async handleExpandStructure() {
      this.generating.expandStruct = true;
      try {
        const params = {
          accountLimit: this.structureParams.accountLimit || 0,
          campaignsMin: this.structureParams.campaignsMin,
          campaignsMax: this.structureParams.campaignsMax,
          adsetsMin: this.structureParams.adsetsMin,
          adsetsMax: this.structureParams.adsetsMax,
          adsMin: this.structureParams.adsMin,
          adsMax: this.structureParams.adsMax
        };
        const range = this.structureParams.expandCreatedTimeRange;
        if (Array.isArray(range) && range.length >= 2 && range[0] && range[1]) {
          params.createdTimeStart = range[0];
          params.createdTimeEnd = range[1];
        }
        const res = await expandStructureFromAccounts(params);
        const d = res.data || {};
        if (d.error) {
          this.$message.warning(d.error);
          this.addLog('warn', '扩展结构: ' + d.error);
          return;
        }
        const msg = '账户' + (d.accountsUsed || 0) + '个, 系列' + (d.campaigns || 0) + ', 组' + (d.adsets || 0) + ', 广告' + (d.ads || 0) + ' (' + (d.totalMs || 0) + 'ms)';
        this.$message.success('基于账户扩展成功! ' + msg);
        this.addLog('success', '扩展结构: ' + msg);
        await this.handleRefreshStats();
      } catch (e) {
        this.$message.error('扩展失败: ' + (e.message || e));
        this.addLog('error', '扩展结构失败: ' + (e.message || e));
      } finally {
        this.generating.expandStruct = false;
      }
    },

    /** 从 AdsBackend 同步数据到本地 PG */
    async handleSyncFromAdsBackend() {
      this.generating.syncAdsBackend = true;
      try {
        const params = {};
        if (this.insightsParams.startDate && this.insightsParams.endDate) {
          params.startDate = this.insightsParams.startDate;
          params.endDate = this.insightsParams.endDate;
        }
        const res = await syncFromAdsBackend(params);
        const msg = (res.data && res.data.message) || 'AdsBackend 数据同步执行完成';
        this.$message.success(msg);
        this.addLog('success', msg);
        await this.handleRefreshStats();
      } catch (e) {
        this.$message.error('同步失败: ' + (e.message || e));
        this.addLog('error', 'AdsBackend 同步失败: ' + (e.message || e));
      } finally {
        this.generating.syncAdsBackend = false;
      }
    },

    /** 生成消耗数据 */
    async handleGenerateInsights() {
      if (!this.insightsParams.startDate || !this.insightsParams.endDate) {
        this.$message.warning('请先选择日期区间');
        return;
      }
      this.generating.insights = true;
      try {
        const res = await generateInsights(this.insightsParams);
        const d = res.data || {};
        const msg = 'CK: ' + (d.ckRows || 0) + '行, PG消耗: ' + (d.consumptions || 0) + ', 广告: ' + (d.ads || 0) + ', ' + (d.days || 0) + '天';
        this.$message.success('消耗数据生成成功! ' + msg);
        this.addLog('success', '生成消耗: ' + msg + ' (' + this.insightsParams.startDate + '~' + this.insightsParams.endDate + ')');
        await this.handleRefreshStats();
      } catch (e) {
        this.$message.error('生成失败: ' + (e.message || e));
        this.addLog('error', '生成消耗数据失败: ' + (e.message || e));
      } finally {
        this.generating.insights = false;
      }
    },

    /** 按当前日期区间清除消耗数据 */
    handleClearCkRange() {
      if (!this.insightsParams.startDate || !this.insightsParams.endDate) {
        this.$message.warning('请先选择日期区间');
        return;
      }
      const range = this.insightsParams.startDate + ' ~ ' + this.insightsParams.endDate;
      this.$confirm('确认清除 [' + range + '] 区间内的测试数据？\nCK fact_insights_daily + CK material_consumption_daily + PG消耗（保留维表和映射）', '警告', {
        confirmButtonText: '确定清除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.clearing.ck = true;
        try {
          const res = await clearCk({ startDate: this.insightsParams.startDate, endDate: this.insightsParams.endDate });
          const d = res.data || {};
          this.$message.success('区间数据已清除');
          this.addLog('success', '清除区间[' + range + ']: 消耗=' + (d.consumptionDeleted || 0));
          await this.handleRefreshStats();
        } catch (e) {
          this.$message.error('清除失败: ' + (e.message || e));
          this.addLog('error', '清除区间失败: ' + (e.message || e));
        } finally {
          this.clearing.ck = false;
        }
      }).catch(() => {});
    },
    /** 一键重建素材消耗（清除→广告结构→消耗→聚合） */
    handleRebuildMaterialConsumption() {
      const params = {
        accounts: this.structureParams.accounts,
        campaignsMin: this.structureParams.campaignsMin,
        campaignsMax: this.structureParams.campaignsMax,
        adsetsMin: this.structureParams.adsetsMin,
        adsetsMax: this.structureParams.adsetsMax,
        adsMin: this.structureParams.adsMin,
        adsMax: this.structureParams.adsMax,
        startDate: this.insightsParams.startDate || null,
        endDate: this.insightsParams.endDate || null,
        spendMin: this.insightsParams.spendMin,
        spendMax: this.insightsParams.spendMax,
        impressionsMin: this.insightsParams.impressionsMin,
        impressionsMax: this.insightsParams.impressionsMax
      };
      if (!params.startDate || !params.endDate) {
        this.$message.warning('请先在「消耗数据管理」中选择日期区间');
        return;
      }
      this.$confirm('确认一键重建？将执行：全量清除 → 生成广告结构 → 生成消耗数据 → 素材消耗聚合。\n需确保已有素材数据。', '一键重建', {
        confirmButtonText: '确定执行',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.generating.rebuild = true;
        try {
          const res = await rebuildMaterialConsumption(params);
          const d = res.data || {};
          this.$message.success('一键重建完成');
          this.addLog('success', '一键重建: ' + JSON.stringify(d));
          await this.handleRefreshStats();
        } catch (e) {
          this.$message.error('重建失败: ' + (e.message || e));
          this.addLog('error', '一键重建失败: ' + (e.message || e));
        } finally {
          this.generating.rebuild = false;
        }
      }).catch(() => {});
    },

    /** 全量清除全套测试数据 */
    handleClearCkAll() {
      this.$confirm('确认全量清除所有测试数据？\nCK + PG维表 + 映射 + 消耗\n此操作不可恢复！', '警告', {
        confirmButtonText: '确定全量清除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.clearing.ckAll = true;
        try {
          const res = await clearCk();
          const d = res.data || {};
          this.$message.success('全套测试数据已清除');
          this.addLog('success', '全量清除: 映射=' + (d.mappingDeleted || 0) + ', 消耗=' + (d.consumptionDeleted || 0) + ', 广告=' + (d.adDeleted || 0));
          await this.handleRefreshStats();
        } catch (e) {
          this.$message.error('清除失败: ' + (e.message || e));
          this.addLog('error', '全量清除失败: ' + (e.message || e));
        } finally {
          this.clearing.ckAll = false;
        }
      }).catch(() => {});
    },

    /** PG→CK 重建（B2 手动同步），支持按维度（level）精确重建 */
    async handleRebuildCkFromPg() {
      this.generating.rebuildCk = true;
      try {
        const params = {};
        if (this.rebuildCkDateRange && this.rebuildCkDateRange.length === 2) {
          params.startDate = this.rebuildCkDateRange[0];
          params.endDate = this.rebuildCkDateRange[1];
        }
        if (this.rebuildCkLevel) {
          params.level = this.rebuildCkLevel;
        }
        const res = await rebuildCkFromPg(params);
        const d = res.data || {};
        if (d.error) {
          this.$message.error('重建失败: ' + d.error);
          this.addLog('error', 'PG→CK重建失败: ' + d.error);
        } else {
          const levelLabel = d.level ? ('[' + d.level + '层]') : '[全维度]';
          const msg = (d.totalRows || 0) + ' 行 ' + levelLabel;
          this.$message.success('PG→CK 重建完成: ' + msg);
          this.addLog('success', 'PG→CK重建: ' + msg + (d.startDate ? ' [' + d.startDate + '~' + d.endDate + ']' : ''));
          await this.handleRefreshStats();
        }
      } catch (e) {
        this.$message.error('重建失败: ' + (e.message || e));
        this.addLog('error', 'PG→CK重建失败: ' + (e.message || e));
      } finally {
        this.generating.rebuildCk = false;
      }
    },

    /** 素材消耗聚合（写入 PG + CK material_consumption_daily） */
    async handleAggregateMaterialConsumption() {
      this.generating.aggregateMat = true;
      try {
        const params = {};
        if (this.aggregateDateRange && this.aggregateDateRange.length === 2) {
          params.startDate = this.aggregateDateRange[0];
          params.endDate = this.aggregateDateRange[1];
        }
        const res = await aggregateMaterialConsumption(params);
        const msg = (res.data && res.data.message) || '素材消耗聚合执行完成';
        this.$message.success(msg);
        this.addLog('success', msg);
        await this.handleRefreshStats();
      } catch (e) {
        this.$message.error('执行失败: ' + (e.message || e));
        this.addLog('error', '素材消耗聚合失败: ' + (e.message || e));
      } finally {
        this.generating.aggregateMat = false;
      }
    },

    async handleStep1() {
      this.generating.step1 = true;
      try {
        const params = {
          mappingCoverage: this.step1Params.mappingCoveragePercent / 100,
          materialCoverage: (this.step1Params.materialCoveragePercent || 0) / 100,
          materialLimit: this.step1Params.materialLimit || 0,
          targetMappingCount: this.step1Params.targetMappingCount || 0,
          clearExisting: this.step1Params.clearExisting
        };
        const res = await step1CreateMapping(params);
        const d = res.data || {};
        if (d.error) {
          this.$message.error(d.error);
          return;
        }
        const msg = '映射: ' + (d.mappingCount || 0) + ' 条, AD总数=' + (d.adTotal || 0) + ', 参与素材=' + (d.materialsUsed || 0);
        this.$message.success('步骤1完成! ' + msg);
        this.addLog('success', '步骤1生成映射: ' + msg);
        await this.handleRefreshStats();
      } catch (e) {
        this.$message.error('步骤1失败: ' + (e.message || e));
        this.addLog('error', '步骤1失败: ' + (e.message || e));
      } finally {
        this.generating.step1 = false;
      }
    },

    async handleStep2() {
      if (!this.step2DateRange || this.step2DateRange.length !== 2) {
        this.$message.warning('请选择日期区间');
        return;
      }
      this.generating.step2 = true;
      try {
        const data = Object.assign({}, this.insightsParams, {
          startDate: this.step2DateRange[0],
          endDate: this.step2DateRange[1]
        });
        const res = await step2GeneratePgInsights(data);
        const d = res.data || {};
        const msg = 'PG fact_insights_daily: ' + (d.pgRows || 0) + ' 行, ' + (d.days || 0) + ' 天';
        this.$message.success('步骤2完成! ' + msg);
        this.addLog('success', '步骤2生成PG消耗: ' + msg);
        await this.handleRefreshStats();
      } catch (e) {
        this.$message.error('步骤2失败: ' + (e.message || e));
        this.addLog('error', '步骤2失败: ' + (e.message || e));
      } finally {
        this.generating.step2 = false;
      }
    },

    async handleStep3() {
      this.generating.step3 = true;
      try {
        const params = {};
        if (this.step3DateRange && this.step3DateRange.length === 2) {
          params.startDate = this.step3DateRange[0];
          params.endDate = this.step3DateRange[1];
        }
        const res = await step3SyncCkAndAggregate(params);
        const d = res.data || {};
        const ck = d.ckRebuild || {};
        const msg = 'CK重建: ' + (ck.totalRows || 0) + ' 行, 聚合完成';
        this.$message.success('步骤3完成! ' + msg);
        this.addLog('success', '步骤3同步CK并聚合: ' + msg);
        await this.handleRefreshStats();
      } catch (e) {
        this.$message.error('步骤3失败: ' + (e.message || e));
        this.addLog('error', '步骤3失败: ' + (e.message || e));
      } finally {
        this.generating.step3 = false;
      }
    },

    /** CK→PG 初始化（首次/回填） */
    async handleInitPgFromCk() {
      this.$confirm('确认将 CK fact_insights_daily 数据迁移到 PG？\n可按当前选择的日期区间执行，不选则全量迁移。', 'CK→PG 初始化', {
        confirmButtonText: '确定执行',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        this.generating.initPg = true;
        try {
          const params = {};
          if (this.insightsParams.startDate && this.insightsParams.endDate) {
            params.startDate = this.insightsParams.startDate;
            params.endDate = this.insightsParams.endDate;
          }
          const res = await initPgFromCk(params);
          const d = res.data || {};
          if (d.error) {
            this.$message.error('初始化失败: ' + d.error);
            this.addLog('error', 'CK→PG初始化失败: ' + d.error);
          } else {
            const msg = (d.totalRows || 0) + ' 行写入 PG';
            this.$message.success('CK→PG 初始化完成: ' + msg);
            this.addLog('success', 'CK→PG初始化: ' + msg);
            await this.handleRefreshStats();
          }
        } catch (e) {
          this.$message.error('初始化失败: ' + (e.message || e));
          this.addLog('error', 'CK→PG初始化失败: ' + (e.message || e));
        } finally {
          this.generating.initPg = false;
        }
      }).catch(() => {});
    },

    /** 清空 CK 表（仅 TRUNCATE fact_insights_daily，不动 PG） */
    handleTruncateCk() {
      this.$confirm('确认清空 CK 消耗表？\n将同时清空 fact_insights_daily 和 material_consumption_daily，PG 数据不受影响。', '警告', {
        confirmButtonText: '确定清空',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.clearing.ckTruncate = true;
        try {
          const res = await clearCk({ truncateCkOnly: true });
          const d = res.data || {};
          this.$message.success('CK 表已清空');
          this.addLog('success', '清空CK表: ' + (d.ck || 'truncated'));
          await this.handleRefreshStats();
        } catch (e) {
          this.$message.error('清空失败: ' + (e.message || e));
          this.addLog('error', '清空CK表失败: ' + (e.message || e));
        } finally {
          this.clearing.ckTruncate = false;
        }
      }).catch(() => {});
    },

    /** 生成测试素材 */
    handleGenerateMaterials() {
      const count = this.materialParams.count;
      const doGenerate = async () => {
        this.generating.materials = true;
        try {
          const res = await generateMaterials(this.materialParams);
          const d = res.data || {};
          const secs = d.totalMs ? (d.totalMs / 1000).toFixed(1) : '0';
          const msg = '文件 ' + (d.success || 0) + ' 个, DB ' + (d.dbInserted || 0) + ' 条'
            + (d.failed > 0 ? ', 失败 ' + d.failed : '')
            + ', ' + (d.dirs || 0) + ' 个目录, 耗时 ' + secs + '秒';
          this.$message.success('测试素材生成完成: ' + msg);
          this.addLog('success', '生成测试素材: ' + msg + ' (类型=' + this.materialParams.type + ', ' + this.materialParams.fileSizeKb + 'KB)');
          await this.handleRefreshStats();
        } catch (e) {
          this.$message.error('生成失败: ' + (e.message || e));
          this.addLog('error', '生成测试素材失败: ' + (e.message || e));
        } finally {
          this.generating.materials = false;
        }
      };
      // 大批量时二次确认
      if (count >= 10000) {
        const sizeMB = (count * this.materialParams.fileSizeKb / 1024).toFixed(1);
        const estSecs = Math.ceil(count / 1500) + '~' + Math.ceil(count / 800);
        this.$confirm(
          '即将生成 ' + count + ' 个测试素材（约 ' + sizeMB + 'MB），预计耗时 ' + estSecs + ' 秒。\n确认继续？',
          '大批量生成确认', { confirmButtonText: '确定生成', cancelButtonText: '取消', type: 'warning' }
        ).then(doGenerate).catch(() => {});
      } else {
        doGenerate();
      }
    },

    /** 清除测试素材 */
    handleClearMaterials() {
      this.$confirm('确认清除所有名称前缀为「' + this.materialParams.namePrefix + '」的测试素材？\n将同时删除物理文件和数据库记录，不可恢复！', '警告', {
        confirmButtonText: '确定清除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.clearing.materials = true;
        try {
          const res = await clearMaterials({ namePrefix: this.materialParams.namePrefix });
          const d = res.data || {};
          const secs = d.totalMs ? (d.totalMs / 1000).toFixed(1) : '0';
          this.$message.success('已清除 ' + (d.dbDeleted || 0) + ' 条DB记录，' + (d.fileDeleted || 0) + ' 个文件，耗时 ' + secs + '秒');
          this.addLog('success', '清除测试素材: DB=' + (d.dbDeleted || 0) + ', 文件=' + (d.fileDeleted || 0) + ', 耗时' + secs + '秒');
          await this.handleRefreshStats();
        } catch (e) {
          this.$message.error('清除失败: ' + (e.message || e));
          this.addLog('error', '清除测试素材失败: ' + (e.message || e));
        } finally {
          this.clearing.materials = false;
        }
      }).catch(() => {});
    },

    /** 添加操作日志 */
    addLog(type, message) {
      const now = new Date();
      const time = now.getHours().toString().padStart(2, '0') + ':' +
                   now.getMinutes().toString().padStart(2, '0') + ':' +
                   now.getSeconds().toString().padStart(2, '0');
      this.logs.unshift({ type, message, time });
      if (this.logs.length > 50) {
        this.logs.length = 50;
      }
    }
  }
};
</script>

<style scoped>
.stat-card {
  text-align: center;
  cursor: default;
}
.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #409EFF;
  margin-bottom: 6px;
}
.stat-value.ck {
  color: #E6A23C;
}
.ck-stat {
  border-top: 2px solid #E6A23C;
}
.stat-label {
  font-size: 13px;
  color: #909399;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}
.card-header i {
  margin-right: 6px;
}
.section-label {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}
.info-text {
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
  margin-top: 8px;
}
.hint-text {
  font-size: 12px;
  color: #C0C4CC;
  margin-left: 8px;
}
.log-container {
  max-height: 300px;
  overflow-y: auto;
}
.log-item {
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.log-time {
  color: #909399;
  font-family: monospace;
  font-size: 12px;
}
.log-msg {
  color: #606266;
}
.step-box {
  padding: 16px 20px;
  border: 1px solid #EBEEF5;
  border-radius: 6px;
  background: #FAFAFA;
  min-height: 320px;
}
.step-box .step-title {
  font-weight: 600;
  margin-bottom: 4px;
  color: #303133;
}
.step-box .step-desc {
  font-size: 12px;
  color: #909399;
  margin-bottom: 12px;
  line-height: 1.5;
}
.step-box .step-form .el-form-item {
  margin-bottom: 12px;
}
.step-box .step-btn {
  margin-top: 12px;
}
.step-box .formula-hint {
  font-size: 11px;
  color: #909399;
  margin-top: 6px;
  padding: 4px 8px;
  background: #F5F7FA;
  border-radius: 4px;
  line-height: 1.4;
}
.param-hint {
  display: block;
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
  line-height: 1.4;
}
.estimate-line {
  font-size: 12px;
  color: #409EFF;
  margin-top: 6px;
  padding: 6px 8px;
  background: #ECF5FF;
  border-radius: 4px;
}
.estimate-line i {
  margin-right: 4px;
}
</style>
